import Head from 'next/head';
import { IMetadata } from './interface';

const Metadata = ({
  title = '',
  description = '',
  keywords = '',
  author = '',
  ogImage = '',
  ogUrl = '',
  twitterCard = '',
  twitterSite = '',
  robots = null,
  richTextContent = null,
  publishedDate = null,
  modifiedDate = null,
  promoPublishedDate = null,
  promoModifiedDate = null,
  canonical = '',
}: IMetadata) => {
  return (
    <Head>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:site" content={twitterSite} />
      {robots && <meta name="robots" content={robots} />}
      {richTextContent && <div dangerouslySetInnerHTML={{ __html: richTextContent }} />}
      {publishedDate && <meta property="article:published_time" content={publishedDate} />}
      {modifiedDate && <meta property="article:modified_time" content={modifiedDate} />}
      {promoModifiedDate && <meta property="promotion:modified_time" content={promoModifiedDate} />}
      {promoPublishedDate && (
        <meta property="promotion:published_time" content={promoPublishedDate} />
      )}
      {canonical && <link rel="canonical" href={canonical} />}
    </Head>
  );
};

export default Metadata;
